// extracted by mini-css-extract-plugin
export default {"layout":"fb1aa5efcc _33ee807f89 _04b230c2e7","h_slide":"f4688c9ad4","category":"e3c4f1738a _574f0fa1ab ba60f7f192"};